import Layout from '@/layout'

const asyncPurchaseRoutes = {
  path: '/purchase/storage',
  component: Layout,
  redirect: 'noRedirect',
  name: '验收入库',
  funcPerms: 'purchase:storage',
  meta: {
    title: '验收入库',
    icon: '',
    affix: false,
    noCache: false
  },
  children: [
    {
      path: '/purchase/storage/apply/purchase_13',
      component: () => import('@/views/purchase/purchaseReceipt/myProcess/index.vue'),
      name: '验收入库申请',
      funcPerms: 'purchase:storage:apply:my:process',
      meta: {
        title: '验收入库申请',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/storage/apply/dept/pass/purchase_13',
      component: () => import('@/views/purchase/purchaseReceipt/todo/index.vue'),
      name: '未审批的验收入库',
      funcPerms: 'purchase:storage:apply:my:todo',
      meta: {
        title: '未审批的验收入库',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/storage/apply/pass/confirm/purchase_13',
      component: () => import('@/views/purchase/purchaseReceipt/finished/index.vue'),
      name: '已审批的验收入库',
      funcPerms: 'purchase:storage:apply:my:finished',
      meta: {
        title: '已审批的验收入库',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/storage/apply/financeConfirm',
      component: () => import('@/views/purchase/purchaseReceipt/list/index.vue'),
      name: '财务确认',
      funcPerms: 'purchase:storage:apply:my:financeConfirm',
      meta: {
        title: '财务入库确认',
        icon: '',
        affix: false,
        noCache: false
      }
    }
  ]
}

export default asyncPurchaseRoutes
